import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    postOcena(idKl, idKu, ocena1, ocena2, ocena3, ocena4, uwagi, plik, plikNazwa, plikRozmiar, plikTyp) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/oceny' + AppConfig.V_LOG(),
            data: {
                "idKl": idKl,
                "idKu": idKu,
                "ocena1": ocena1,
                "ocena2": ocena2,
                "ocena3": ocena3,
                "ocena4": ocena4,
                "uwagi": uwagi,
                "plik": plik,
                "plikNazwa": plikNazwa,
                "plikRozmiar": plikRozmiar,
                "plikTyp": plikTyp
            }
        });
    },

    postZgloszenie(email, imie, nazwisko, nrRez, plik, plikNazwa, plikRozmiar, plikTyp, temat, tresc, idKl) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/bok/zgl' + AppConfig.V_LOG(),
            data:
                {
                    "emailKl": email,
                    "imieKl": imie,
                    "nazKl": nazwisko,
                    "nrBil": nrRez,
                    "plik": plik,
                    "plikNazwa": plikNazwa,
                    "plikRozmiar": plikRozmiar,
                    "plikTyp": plikTyp,
                    "temat": temat,
                    "tresc": tresc,
                    "wpisalId": idKl
                }
        });
    },

    postZgloszenieNieZal(email, imie, nazwisko, nrRez, plik, plikNazwa, plikRozmiar, plikTyp, temat, tresc, idKl) {
        return axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/bok/zgl' + AppConfig.V_LOG(),
            data:
                {
                    "emailKl": email,
                    "imieKl": imie,
                    "nazKl": nazwisko,
                    "nrBil": nrRez,
                    "plik": plik,
                    "plikNazwa": plikNazwa,
                    "plikRozmiar": plikRozmiar,
                    "plikTyp": plikTyp,
                    "temat": temat,
                    "tresc": tresc,
                    "wpisalId": idKl
                }
        });
    },

    postZgloszenieId(plik, plikNazwa, plikRozmiar, plikTyp, tresc, idKl, idZgl) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/zgl/zgloszenie/' + idZgl + AppConfig.V_LOG(),
            data:
                {
                    "plik": plik,
                    "plikNazwa": plikNazwa,
                    "plikRozmiar": plikRozmiar,
                    "plikTyp": plikTyp,
                    "tresc": tresc,
                    "wpisalId": idKl
                }
        });
    },

    getZgloszenia(idKl) {
        return axios({
            method: 'GET',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/zgl/klient/' + idKl + AppConfig.V_LOG(),
        });
    },

    getZgloszenie(idZgl) {
        return axios({
            method: 'GET',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/zgl/zgloszenie/' + idZgl + AppConfig.V_LOG(),
        });
    },

    postZamknij(idZgl) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/zgl/zgloszenie/' + idZgl + '/zamknij' + AppConfig.V_LOG(),
        });
    },

    postOdczytano(idZgl) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bok/zgl/zgloszenie/' + idZgl + '/odczytano' + AppConfig.V_LOG(),
        });
    },
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/bokComponents/BOKService.js